// Save Map State
export const saveMapStateUrl =
  "/api/v3/campaign/:campaignId/city/:cityId/map-state";

// Restore Map State
export const restoreMapStateUrl =
  "/api/v3/campaign/:campaignId/city/:cityId/map-state";
